<template>
  <ValidationObserver  v-slot="validationProps" slim>
      <div
          :step-id="id"
          :title="title"
          :invalid="validationProps.invalid" class="form-step">
        <fieldset>
          <slot></slot>
        </fieldset>
      </div>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
export default {
  name: "FormStep.vue",
  components: {
    ValidationObserver,
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    id: String,
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
